export const deleteCookie = (name) => {
	const subDomainDot = process.env.NODE_ENV === 'production' ? '.' : ''
	document.cookie = `${name}=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/; domain=${subDomainDot}${window.location.hostname};`
}

export const getCookie = (name) => {
	let cookie = document.cookie

	if (!cookie) return false

	cookie = cookie.split(';').find(row => row.trim().startsWith(name))

	return cookie
		? cookie.split('=')[1]
		: false
}

export const setDomainCookie = (val, name = 'auth', expiresInHours) => {
	const cookieExpires = new Date()
	cookieExpires.setHours(cookieExpires.getHours() + expiresInHours)

	const secure = process.env.NODE_ENV === 'production' ? ' secure' : ''
	const subDomainDot = process.env.NODE_ENV === 'production' ? '.' : ''

	return document.cookie =
		`${name}=${val}; expires=${cookieExpires}; domain=${subDomainDot}${window.location.hostname}; path=/; sameSite=strict;${secure}`
}